import Vue from 'vue'
import PassportEdit from './vehiclePassport/Edit'
import PassportView from './vehiclePassport/View'
import OsagoEdit from './osago/Edit'
import OsagoView from './osago/View'
import StsEdit from './sts/Edit'
import StsView from './sts/View'
import State from './State'
import DocumentPassCarriageLicenceEdit from './passCarriageLicence/Edit'
import DocumentPassCarriageLicenceView from './passCarriageLicence/View'

Vue.component('DocumentPassCarriageLicenceEdit', DocumentPassCarriageLicenceEdit)
Vue.component('DocumentPassCarriageLicenceView', DocumentPassCarriageLicenceView)
Vue.component('DocumentVehiclePassportEdit', PassportEdit)
Vue.component('DocumentVehiclePassportView', PassportView)
Vue.component('DocumentOsagoEdit', OsagoEdit)
Vue.component('DocumentOsagoView', OsagoView)
Vue.component('DocumentStsEdit', StsEdit)
Vue.component('DocumentStsView', StsView)
Vue.component('State', State)
